import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { getClientsCatalog } from "./Integracion";
import { useNavigate } from "react-router-dom";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

export default function CustomerCatalog() {
    const [customers, setCustomers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        getClientsCatalog().then(setCustomers);
    }, []);

    const isExpired = (fecha) => new Date(fecha) < new Date();

    const filtered = customers.filter(c =>
        c.empresa.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const grouped = filtered.reduce((acc, c) => {
        (acc[c.categoria] = acc[c.categoria] || []).push(c);
        return acc;
    }, {});

    const rows = Object.entries(grouped).flatMap(([categoria, items]) =>
        items.map((c, i) => ({ ...c, _cat: categoria, _catSize: items.length, _catFirst: i === 0 }))
    );

    return (
        <div className="pt-3">
            {/* Search bar */}
            <div className="flex align-items-center gap-2 p-3 surface-card border-round shadow-1 mb-3">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Buscar por empresa..."
                        className="w-full"
                    />
                </IconField>

                {searchTerm && (
                    <Button icon="pi pi-times" text severity="secondary" onClick={() => setSearchTerm('')} />
                )}
                <Button
                    label="Nuevo cliente"
                    icon="pi pi-plus"
                    severity="success"
                    onClick={() => navigate('/comercial/catalogo-clientes/nuevo')}
                />
            </div>

            {searchTerm && (
                <p className="text-color-secondary text-sm mb-2">
                    {filtered.length} resultado{filtered.length !== 1 ? 's' : ''}
                </p>
            )}

            {/* Tabla con rowspan */}
            <div className="surface-card border-round shadow-1 overflow-hidden">
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                    <tr className="surface-ground">
                        {['Categoría', 'Empresa', 'Razón Social', 'Teléfono', 'Crédito', 'Vencimiento', 'Estado', ''].map(h => (
                            <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, fontSize: '12px', borderBottom: '1px solid var(--surface-border)', color: 'var(--text-color-secondary)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                {h}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {rows.length === 0 ? (
                        <tr><td colSpan={8} style={{ textAlign: 'center', padding: '32px', color: 'var(--text-color-secondary)' }}>No se encontraron clientes</td></tr>
                    ) : rows.map((c) => {
                        const expired = isExpired(c.vencimientoContrato);
                        return (
                            <tr key={c.id} style={{ borderBottom: '1px solid var(--surface-border)' }}>
                                {c._catFirst && (
                                    <td
                                        rowSpan={c._catSize}
                                        style={{ background: 'var(--surface-ground)', textAlign: 'center', verticalAlign: 'top', padding: '12px 8px', borderRight: '1px solid var(--surface-border)', fontWeight: 500, fontSize: '12px' }}
                                    >
                                        <div style={{ marginBottom: '4px' }}>{c._cat}</div>
                                        <Tag value={`${c._catSize}`} severity="secondary" />
                                    </td>
                                )}
                                <td style={{ padding: '10px 14px' }}>{c.empresa}</td>
                                <td style={{ padding: '10px 14px', color: 'var(--text-color-secondary)' }}>{c.razonSocial}</td>
                                <td style={{ padding: '10px 14px', color: 'var(--text-color-secondary)' }}>{c.telefono1}</td>
                                <td style={{ padding: '10px 14px' }}>
                                    <Tag value={c.credito ? 'Sí' : 'No'} severity={c.credito ? 'success' : 'danger'} />
                                </td>
                                <td style={{ padding: '10px 14px', color: 'var(--text-color-secondary)' }}>{c.vencimientoContrato}</td>
                                <td style={{ padding: '10px 14px' }}>
                                    <Tag value={expired ? 'Vencido' : 'Vigente'} severity={expired ? 'danger' : 'success'} />
                                </td>
                                <td style={{ padding: '10px 14px' }}>
                                    <Button
                                        icon="pi pi-pencil"
                                        rounded text severity="info"
                                        onClick={() => navigate(`/comercial/catalogo-clientes/${c.id}`)}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}